import React from 'react';
import i18n from 'i18n-js';
import moment from 'moment';
import { View } from 'react-native';
import Image from '@v2/context/Image/context';
import { DATA_GRID_IMAGE_COLUMN_WIDTH } from '@v2/pages/common/constants/base.constants';
import { ProductionBatch } from '@interfaces/search';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { DOCUMENT_ENTITY_TYPE, IMAGE_HANDLING_CONTEXT } from '@components/imageHandling/common';

interface BatchDataGridColumnsParams {
  scale: ScaleFunction;
  goToDetails: (item: ProductionBatch) => void;
}

export const getBatchDataGridColumns = ({ scale, goToDetails }: BatchDataGridColumnsParams) => [
  {
    field: 'Image',
    headerName: '',
    align: 'center',
    width: scale(DATA_GRID_IMAGE_COLUMN_WIDTH),
    sortable: false,
    filterable: false,
    renderCell: ({ row }: { row: ProductionBatch }) => {
      const imgSize = { width: scale(50), height: scale(30) };
      const imageData = {
        image: {
          documentId: row.imageDocumentId,
          imageHash: row.imageHash,
          imageData: row.imageData
            ? {
                isCropped: row.imageData.isCropped,
                extensionDerivative: row.imageData.extensionDerivative,
                pageNumber: row.imageData.pageNumber,
                rotationAngle: row.imageData.rotationAngle || 0,
                rotationAngleCrop: row.imageData.rotationAngle || 0,
              }
            : undefined,
          width: imgSize.width,
          height: imgSize.height,
          contextId: row.productionBatchId,
          contextCode: IMAGE_HANDLING_CONTEXT[DOCUMENT_ENTITY_TYPE.Batch],
        },
        onPress: () => goToDetails(row),
      };
      return (
        <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
          <Image {...imageData} />
        </View>
      );
    },
  },
  {
    field: 'batchNumber',
    headerName: i18n.t('Batch Number'),
    align: 'left',
    width: scale(150),
    sortable: true,
    filterable: true,
  },
  {
    field: 'ncFileName',
    headerName: i18n.t('NC File'),
    align: 'left',
    flex: 1,
    sortable: true,
    filterable: true,
  },
  {
    field: 'machineShortName',
    headerName: i18n.t('Machine'),
    align: 'left',
    width: scale(120),
    sortable: true,
    filterable: true,
  },
  {
    field: 'quantity',
    headerName: i18n.t('Qty'),
    align: 'center',
    width: scale(80),
    sortable: true,
    filterable: true,
  },
  {
    field: 'startedOn',
    headerName: i18n.t('Start'),
    align: 'right',
    headerAlign: 'right',
    width: scale(120),
    type: 'date',
    sortable: true,
    filterable: true,
    valueGetter: (value: string) => (value ? new Date(value) : value),
    valueFormatter: (value: Date) => (value ? moment(value).format('DD/MM/YYYY') : ''),
  },
  {
    field: 'endedOn',
    headerName: i18n.t('End'),
    align: 'right',
    headerAlign: 'right',
    width: scale(120),
    type: 'date',
    sortable: true,
    filterable: true,
    valueGetter: (value: string) => (value ? new Date(value) : value),
    valueFormatter: (value: Date, row: ProductionBatch) =>
      row.isInProgress ? i18n.t('In Progress') : value ? moment(value).format('DD/MM/YYYY') : '',
  },
  {
    field: 'linkStatus',
    headerName: i18n.t('Link'),
    align: 'center',
    width: scale(100),
    sortable: true,
    filterable: true,
  },
];
